import { FC } from 'react'
import { toast } from 'react-toastify'
import { styles } from './ProRithmDasboard'
import { useAppDispatch } from '../../app/hooks'
import { setAddDeviceCount } from './ProrithmSlice'
import { deleteProrithmDevice } from '../../services/ProrithmServices'
import { constants, messages, ProrithmSocketMessage } from './Constants'
import {
  Button,
  Dialog,
  useTheme,
  DialogTitle,
  DialogActions,
} from '@mui/material'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'

interface DeleteDeviceDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
  mappingId: string | null
  deviceId: string
  sendMessageOnSocket: (payload: ProrithmSocketMessage) => void
}

const DeleteDeviceDialog: FC<DeleteDeviceDialogProps> = ({
  open,
  setOpen,
  mappingId,
  deviceId,
  sendMessageOnSocket,
}) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const classes = useCustomStyles(styles, theme)

  const removeProrithmDevice = async () => {
    setOpen(false)
    const result = await deleteProrithmDevice(mappingId ?? '')
    if (result?.success) {
      dispatch(setAddDeviceCount())
      toast(result?.message ?? messages?.deviceDeletedSuccessfully, {
        position: 'bottom-center',
        hideProgressBar: true,
        closeButton: false,
        theme: 'dark',
        autoClose: 4000,
      })

      const deleteDeviceMessage = {
        messageType: constants?.deleteText,
        messageContent: {
          message: `${deviceId} ${result?.message}.`,
          macId: deviceId ?? '',
          category: constants?.notMapped,
        },
      }
      sendMessageOnSocket(deleteDeviceMessage)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      id='delete-device-dialog'
    >
      <DialogTitle id='delete-device-dialog-title'>
        {constants?.askDeleteDevice}
      </DialogTitle>
      <DialogActions>
        <Button
          size='small'
          variant='contained'
          onClick={() => setOpen(false)}
          id='close-delete-device-dialog-btn'
          className={classes?.proRithmDasboardCreateBtn}
        >
          {constants?.no}
        </Button>
        <Button
          autoFocus
          size='small'
          variant='contained'
          id='delete-device-btn'
          onClick={removeProrithmDevice}
          className={classes?.proRithmDasboardCreateBtn}
        >
          {constants?.yes}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteDeviceDialog
